import React from 'react';
import Link from 'next/link';
import { Row, Col, Typography, Card } from 'antd';

import Footer from '@/components/Footer';
import Logo from '@/components/Logo';

const { Title, Paragraph } = Typography;

const PrivacyPage = (): JSX.Element => {
  return (
    <Row style={{ minHeight: '100vh' }} className="shophil-bg">
      <Col
        md={{ span: 12, offset: 6 }}
        sm={{ span: 22, offset: 1 }}
        xs={{ span: 22, offset: 1 }}>
        <Link href="/">
          <a>
            <Logo type="small" />
          </a>
        </Link>
        <Card>
          <Title level={1}>Privacy Policy</Title>
          <Paragraph>Effective date: February 24, 2019</Paragraph>
          <Paragraph>
            Shophil (&quot;us&quot;, &quot;we&quot;, or &quot;our&quot;)
            operates the shophil.com website (hereinafter referred to as the
            &quot;Service&quot;).
          </Paragraph>
          <Paragraph>
            This page informs you of our policies regarding the collection, use,
            and disclosure of personal data when you use our Service and the
            choices you have associated with that data.
          </Paragraph>
          <Paragraph>
            We use your data to provide and improve the Service. By using the
            Service, you agree to the collection and use of information in
            accordance with this policy. Unless otherwise defined in this
            Privacy Policy, the terms used in this Privacy Policy have the same
            meanings as in our Terms and Conditions, accessible from shophil.com
          </Paragraph>
          <Title level={2}>Information Collection And Use</Title>
          <Paragraph>
            We collect several different types of information for various
            purposes to provide and improve our Service to you.
          </Paragraph>
          <Title level={2}>Types of Data Collected</Title>
          <Title level={4}>Personal Data</Title>
          <Paragraph>
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you (&quot;Personal Data&quot;). Personally identifiable
            information may include, but is not limited to:
          </Paragraph>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Cookies and Usage Data</li>
          </ul>
          <Title level={4}>Usage Data</Title>
          <Paragraph>
            We may also collect information on how the Service is accessed and
            used (&quot;Usage Data&quot;). This Usage Data may include
            information such as your computer&quot;s Internet Protocol address
            (e.g. IP address), browser type, browser version, the pages of our
            Service that you visit, the time and date of your visit, the time
            spent on those pages, unique device identifiers and other diagnostic
            data.
          </Paragraph>
          <Title level={4}>Tracking & Cookies Data</Title>
          <Paragraph>
            We use cookies and similar tracking technologies to track the
            activity on our Service and hold certain information.
          </Paragraph>
          <Paragraph>
            Cookies are files with small amount of data which may include an
            anonymous unique identifier. Cookies are sent to your browser from a
            website and stored on your device. Tracking technologies also used
            are beacons, tags, and scripts to collect and track information and
            to improve and analyze our Service.
          </Paragraph>
          <Paragraph>
            You can instruct your browser to refuse all cookies or to indicate
            when a cookie is being sent. However, if you do not accept cookies,
            you may not be able to use some portions of our Service.
          </Paragraph>
          <Paragraph>Examples of Cookies we use:</Paragraph>
          <ul>
            <li>
              <strong>Session Cookies.</strong> We use Session Cookies to
              operate our Service.
            </li>
            <li>
              <strong>Preference Cookies.</strong> We use Preference Cookies to
              remember your preferences and various settings.
            </li>
            <li>
              <strong>Security Cookies.</strong> We use Security Cookies for
              security purposes.
            </li>
          </ul>
          <Title level={2}>Use of Data</Title>
          <Paragraph>
            Shophil uses the collected data for various purposes:
          </Paragraph>
          <ul>
            <li>To provide and maintain the Service</li>
            <li>To notify you about changes to our Service</li>
            <li>
              To allow you to participate in interactive features of our Service
              when you choose to do so
            </li>
            <li>To provide customer care and support</li>
            <li>
              To provide analysis or valuable information so that we can improve
              the Service
            </li>
            <li>To monitor the usage of the Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
          <Title level={2}>Transfer Of Data</Title>
          <Paragraph>
            Your information, including Personal Data, may be transferred to —
            and maintained on — computers located outside of your state,
            province, country or other governmental jurisdiction where the data
            protection laws may differ than those from your jurisdiction.
          </Paragraph>
          <Paragraph>
            If you are located outside Singapore and choose to provide
            information to us, please note that we transfer the data, including
            Personal Data, to Singapore and process it there.
          </Paragraph>
          <Paragraph>
            Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer.
          </Paragraph>
          <Paragraph>
            Shophil will take all steps reasonably necessary to ensure that your
            data is treated securely and in accordance with this Privacy Policy
            and no transfer of your Personal Data will take place to an
            organization or a country unless there are adequate controls in
            place including the security of your data and other personal
            information.
          </Paragraph>
          <Title level={2}>Disclosure Of Data</Title>
          <Title level={4}>Legal Requirements</Title>
          <Paragraph>
            Shophil may disclose your Personal Data in the good faith belief
            that such action is necessary to:
          </Paragraph>
          <ul>
            <li>To comply with a legal obligation</li>
            <li>To protect and defend the rights or property of Shophil</li>
            <li>
              To prevent or investigate possible wrongdoing in connection with
              the Service
            </li>
            <li>
              To protect the personal safety of users of the Service or the
              public
            </li>
            <li>To protect against legal liability Security Of Data</li>
          </ul>
          <Title level={2}>Security Of Data</Title>
          <Paragraph>
            The security of your data is important to us, but remember that no
            method of transmission over the Internet, or method of electronic
            storage is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee
            its absolute security.
          </Paragraph>
          <Title level={2}>Service Providers</Title>
          <Paragraph>
            We may employ third party companies and individuals to facilitate
            our Service (&quot;Service Providers&quot;), to provide the Service
            on our behalf, to perform Service-related services or to assist us
            in analyzing how our Service is used.
          </Paragraph>
          <Paragraph>
            These third parties have access to your Personal Data only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose.
          </Paragraph>
          <Title level={2}>Analytics</Title>
          <Paragraph>
            We may use third-party Service Providers to monitor and analyze the
            use of our Service.
          </Paragraph>
          <ul>
            <li>
              Google Analytics is a web analytics service offered by Google that
              tracks and reports website traffic. Google uses the data collected
              to track and monitor the use of our Service. This data is shared
              with other Google services. Google may use the collected data to
              contextualize and personalize the ads of its own advertising
              network.
            </li>
            <li>
              You can opt-out of having made your activity on the Service
              available to Google Analytics by installing the Google Analytics
              opt-out browser add-on. The add-on prevents the Google Analytics
              JavaScript (ga.js, analytics.js, and dc.js) from sharing
              information with Google Analytics about visits activity.
            </li>
            <li>
              For more information on the privacy practices of Google, please
              visit the Google Privacy & Terms web page:
              <a href="http://www.google.com/intl/en/policies/privacy/">
                http://www.google.com/intl/en/policies/privacy/
              </a>
            </li>
          </ul>
          <Title level={2}>Links To Other Sites</Title>
          <Paragraph>
            Our Service may contain links to other sites that are not operated
            by us. If you click on a third party link, you will be directed to
            that third party&quot;s site. We strongly advise you to review the
            Privacy Policy of every site you visit.
          </Paragraph>
          <Paragraph>
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </Paragraph>
          <Title level={2}>Children&quot;s Privacy</Title>
          <Paragraph>
            Our Service does not address anyone under the age of 18
            (&quot;Children&quot;).
          </Paragraph>
          <Paragraph>
            We do not knowingly collect personally identifiable information from
            anyone under the age of 18. If you are a parent or guardian and you
            are aware that your Children has provided us with Personal Data,
            please contact us. If we become aware that we have collected
            Personal Data from children without verification of parental
            consent, we take steps to remove that information from our servers.
          </Paragraph>
          <Title level={2}>Changes To This Privacy Policy</Title>
          <Paragraph>
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </Paragraph>
          <Paragraph>
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update the
            &quot;effective date&quot; at the top of this Privacy Policy.
          </Paragraph>
          <Paragraph>
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </Paragraph>
          <Title level={2}>Contact Us</Title>
          <Paragraph>
            If you have any questions about this Privacy Policy, please contact
            us
          </Paragraph>
        </Card>
        <Footer />
      </Col>
    </Row>
  );
};

export default PrivacyPage;
